const projects = [{
        title: "Tic Tac Toe AI",
        demo: "https://noahhendlish.github.io/Tic-Tac-Toe/",
        repo: 'https://github.com/noahhendlish/Tic-Tac-Toe'
    },
    {
        title: "Better Gibson",
        repo: "https://github.com/noahhendlish/bettergibson",
        demo: "https://better-gibson.herokuapp.com/"
    },
    {
        title: "Malicious Tweets Classifier",
        repo: "https://github.com/noahhendlish/MachineLearningTwitterProject",
        demo: "https://feedar.herokuapp.com/",
        //demo2: "https://github.com/noahhendlish/capstoneresearchposter"
    },

];
export default projects;